import { Component, ViewChild } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NotificationService, Notification, NotificationComponent, DialogService } from '../../../shared/index'; //app/shared/index barrel;
import { ActivatedRoute } from '@angular/router';
import { EventsService } from '../../shared/events.service';
import { ConfigService } from '../../../config/shared/config.service';
import { EventRead } from '../../shared/event-read.model';
import { EventCopy } from '../../shared/event-copy.model';
import { Router } from '@angular/router';
import { RegistrationWizardComponent } from '../../registration/wizard/registration-wizard.component';

@Component({
  selector: 'wl-event-registration-dashboard',
  templateUrl: 'registration-dashboard.component.html',
  providers: [EventsService, ConfigService],
    standalone: false
})
export class EventRegistrationDashboardComponent {
  @ViewChild('registrationWizard', { static: false }) registrationWizard: RegistrationWizardComponent;

  public id: number;
  public event: EventRead;
  public eventUrl: string;
  public copyMessage: string;

  constructor(
    public _route: ActivatedRoute,
    public _eventsService: EventsService,
    public _dialogService: DialogService,
    public _configService: ConfigService,
    public _translateService: TranslateService,
    public _router: Router
  ) {}

  ngOnInit() {
    this._route.paramMap
      //.map(params => params['id'])
      .subscribe(params => {
        this.id = parseInt(params.get('id'));
      });
  }
}
